import { render, staticRenderFns } from "./MainCategories.vue?vue&type=template&id=3cf6e082&scoped=true&"
import script from "./MainCategories.vue?vue&type=script&lang=js&"
export * from "./MainCategories.vue?vue&type=script&lang=js&"
import style0 from "./MainCategories.vue?vue&type=style&index=0&id=3cf6e082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6e082",
  null
  
)

export default component.exports